import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { DeviceCardRowProps } from '@/console/features/card-layout/components/recent-devices-card/components/device-card-row/device-card-row.types';
import { useLinkedGatewaysForDevice } from '@/console/features/devices/hooks/use-linked-gateways-for-device/use-linked-gateways-for-device';
import { GatewayHealthChip } from '@/console/features/gateways/components/gateway-health-chip/gateway-health-chip';
import { DevicesIcon } from '@/shared/assets/icons/devices-icon';
import { OpenIcon } from '@/shared/assets/icons/open-icon';
import { ListItemDescription } from '@/shared/components/ui/list-item-description/list-item-description';
import { useEnumLabel } from '@/shared/hooks/use-enum-label/use-enum-label';
import { useVendor } from '@/shared/hooks/use-vendor/use-vendor';
import { devicesApi } from '@/shared/redux/api/assets/devices/devices-api';

export const DeviceCardRow: React.FC<DeviceCardRowProps> = ({ device }) => {
  const { getEnumLabel } = useEnumLabel();
  const navigate = useNavigate();
  const { getVendor } = useVendor();
  const { primaryGateway } = useLinkedGatewaysForDevice(device);
  const vendor = getVendor(device)?.name;

  const prefetchDevice = devicesApi.usePrefetch('ReadDevice');

  return (
    <Stack
      onMouseEnter={() => prefetchDevice({ deviceId: device.deviceId })}
      onClick={() => navigate(`/devices/${device.deviceId}`)}
      direction="row"
      justifyContent="space-between"
      width="100%"
    >
      <Stack gap="0.625rem" direction="row">
        <DevicesIcon variant="primary" />
        <Stack gap="0.5rem">
          <Typography variant="p7">{device.name}</Typography>
          <ListItemDescription
            text1={getEnumLabel(device.deviceType, 'device:device_types')}
            text2={vendor}
          />
          <Stack direction="row" gap="0.5rem">
            <GatewayHealthChip
              gatewayName={primaryGateway?.name}
              gatewayId={primaryGateway?.gatewayId}
              descriptiveTooltip
            />
          </Stack>
        </Stack>
      </Stack>
      <OpenIcon variant="light" />
    </Stack>
  );
};
